var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "role_group_cla" },
    [
      _c("zk-button-group", {
        attrs: { toolBar: true, event: ["addRole", "addRoleGroup"] },
        on: { addRole: _vm.addRoleDia, addRoleGroup: _vm.RoleGroupDia }
      }),
      _vm._v(" "),
      _c(
        "el-menu",
        {
          attrs: { "default-active": _vm.defaultActive, "unique-opened": true },
          on: { select: _vm.menuSelect }
        },
        _vm._l(_vm.roleTreeData, function(item) {
          return _c(
            "el-submenu",
            {
              key: item.id,
              staticClass: "sub_menu_cla",
              attrs: { index: item.id, name: item.id }
            },
            [
              _c("template", { slot: "title" }, [
                _c("span", [_vm._v(_vm._s(item.name))]),
                _vm._v(" "),
                item.editable
                  ? _c("span", [
                      _c("i", {
                        staticClass:
                          "sub_menu_icon_cla role_icon_cla zk-icon-md-close",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.removeRoleGroupConfirm(item)
                          }
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                item.editable
                  ? _c(
                      "span",
                      {
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.RoleGroupDia(item)
                          }
                        }
                      },
                      [
                        _c("i", {
                          staticClass:
                            "sub_menu_icon_cla role_icon_cla zk-icon-pencil"
                        })
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm._l(item.roleList, function(menuItem) {
                return _c(
                  "el-menu-item",
                  {
                    key: menuItem.id,
                    staticClass: "sub_menu_item_cla",
                    attrs: { index: menuItem.id, name: menuItem.id }
                  },
                  [
                    _c("span", [_vm._v(_vm._s(menuItem.name))]),
                    _vm._v(" "),
                    menuItem.editable
                      ? _c("span", [
                          _c("i", {
                            staticClass: "role_icon_cla zk-icon-md-close",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.deleteRoleConfirm(menuItem)
                              }
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    menuItem.editable
                      ? _c("span", [
                          _c("i", {
                            staticClass: "role_icon_cla zk-icon-pencil",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.updateRole(menuItem)
                              }
                            }
                          })
                        ])
                      : _vm._e()
                  ]
                )
              })
            ],
            2
          )
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": true,
            title: _vm.$t("role.roleGroup"),
            "close-on-click-modal": false,
            visible: _vm.showRoleGroupDia,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.showRoleGroupDia = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "formValidate",
              attrs: {
                model: _vm.roleGroupForm,
                "label-width": "170px",
                rules: _vm.roleGroupValidate
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("role.roleGroupName"), prop: "name" }
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: _vm.$t("role.roleGroupNameRequire") },
                    model: {
                      value: _vm.roleGroupForm.name,
                      callback: function($$v) {
                        _vm.$set(_vm.roleGroupForm, "name", $$v)
                      },
                      expression: "roleGroupForm.name"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      _vm.showRoleGroupDia = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.addRoleGroup($event)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.confirm")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("role.role"),
            "close-on-click-modal": false,
            visible: _vm.showRoleDia,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.showRoleDia = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "roleFormValidate",
              attrs: {
                model: _vm.roleForm,
                "label-width": "140px",
                rules: _vm.roleFormValidate
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("role.roleGroup"), prop: "groupID" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: _vm.$t("role.roleGroupRequire") },
                      model: {
                        value: _vm.roleForm.groupID,
                        callback: function($$v) {
                          _vm.$set(_vm.roleForm, "groupID", $$v)
                        },
                        expression: "roleForm.groupID"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("role.noGroup"),
                          value: "nongrouping"
                        }
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.roleTreeData, function(item) {
                        return [
                          item.id !== "nongrouping"
                            ? _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id }
                              })
                            : _vm._e()
                        ]
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("role.roleName"), prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: _vm.$t("role.roleNameRequire") },
                    model: {
                      value: _vm.roleForm.name,
                      callback: function($$v) {
                        _vm.$set(_vm.roleForm, "name", $$v)
                      },
                      expression: "roleForm.name"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      _vm.showRoleDia = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.saveRole($event)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.confirm")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bd79858c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd79858c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/cdpBase/baseComponents/roleGroup/src/main.vue
// module id = null
// module chunks = 